import React from 'react'


import { CustomerText } from '../CustomerText'
import { GetPresignedUrl, PostCase } from '../Api'
import Config from '../Config'
import { Buffer } from 'buffer'

const UploadImgType = ['JPG', 'JPEG', 'PNG', 'GIF', 'PDF']
const UploadImgMaxSize = 5 * 1024 * 1024
const UploadImgMaxLength = 3
const MaxLength = 500

const { Language, ModalTip } = Config()
const { Confirm } = ModalTip
let tempText = CustomerText[Language]


export default class FeedbackCom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            questionTypesIndex: -999,
            questionTypes: this.props.questionTypes,
            questionInputText: '',


            uploadImageData: [],


            isQuestionModalVisible: false,
            isUploadModalVisible: false,

            isShowCaptcha: false
        }
    }

    componentWillUnmount() {
        this.props.getFeedBackLeaveStatus({
            isAllowFeedBackLeave: false
        })
    }

    selectQuestionTypes({ isQuestionModalVisible = false, questionTypesIndex = -999 }) {
        this.setState({
            isQuestionModalVisible,
            questionTypesIndex
        }, () => {
            this.getFeedBackLeaveStatus({})
        })
    }

    changeQuestionInputText(questionInputText) {
        this.setState({
            questionInputText
        }, () => {
            this.getFeedBackLeaveStatus({})
        })
    }

    getFeedBackLeaveStatus({ type }) {
        let { questionTypesIndex, questionInputText, uploadImageData } = this.state
        this.props.getFeedBackLeaveStatus({
            isAllowFeedBackLeave: Boolean(questionTypesIndex >= 0 || !!questionInputText || (Array.isArray(uploadImageData) && !!uploadImageData.length)),
            type
        })
    }

    deleteModal({ callBack }) {
        Confirm({
            title: '',
            children: tempText?.text33,
            noBtnTxt: tempText?.text34,
            noFunction: () => {

            },
            okBtnTxt: tempText?.text35,
            okFunction: () => {
                callBack()
            }
        })
    }


    async selectUplodType({ type = '', uploadData = {}, uploadImgIndex, isUploadModalVisible, callBack = () => { } }) {
        this.setState({
            isUploadModalVisible
        })
        let { uploadImageData } = this.state

        if (type == 'add') {
            const { fileName, fileSize, fileBytes } = uploadData
            let fileNameArr = fileName.split('.')
            let imgType = fileNameArr[fileNameArr.length - 1]?.toLocaleUpperCase()
            let isAllowImgType = UploadImgType.some(v => v == imgType)
            let isAllowImgSize = UploadImgMaxSize >= fileSize

            if (!isAllowImgType || !isAllowImgSize) {
                callBack({
                    text1: tempText?.text63,
                    text2: tempText?.text62,
                })
                return
            }

            uploadImageData.push(uploadData)

            this.setState({
                uploadImageData,
            })
        } else if (type == 'delete') {
            this.deleteModal({
                callBack: () => {
                    uploadImageData[uploadImgIndex] = ''
                    this.setState({
                        uploadImageData: this.state.uploadImageData.filter(Boolean),
                    })
                }
            })
        }
    }


    async onSubmit(type) {
        // if (Config()?.userName) {
        //     if (type == 'open') {
        //         this.setState({
        //             isShowCaptcha: true
        //         })
        //         return
        //     } else if (type == 'close') {
        //         this.setState({
        //             isShowCaptcha: false
        //         })
        //         return
        //     }
        // }

        this.setState({
            isShowCaptcha: false
        })
        let { questionTypes, questionTypesIndex, questionInputText, uploadImageData } = this.state

        let objectKeys = []
        if ((Array.isArray(uploadImageData) && uploadImageData.length)) {
            let data = await this.getPresignedUrl(uploadImageData) || []
            objectKeys = data.map(v => v.objectKey)
        }

        let { questionTypeID, questionType } = questionTypes[questionTypesIndex]
        let PostCaseparams = {
            subject: questionType,
            description: questionInputText,
            category: questionTypeID,
            objectKeys
        }
        let res = await PostCase(PostCaseparams)
        if (res) {
            this.setState({
                questionTypesIndex: -999,
                questionInputText: '',
            }, () => {
                this.getFeedBackLeaveStatus({
                    type: 'submit'
                })
            })
        }
    }

    async getPresignedUrl(uploadImageData) {
        // Hi sir
        // according to the code
        // the Filename.Length must be less than or equal to 15
        let params = {
            filename: uploadImageData.map(v => v.fileName.slice(-15)),
            urlType: 'upload',
        }
        let data = await GetPresignedUrl(params)
        if (Array.isArray(data) && data.length) {
            for (let i = 0; i < data.length; i++) {
                data[i].fileBytes = uploadImageData[i].fileBytes
                await this.uploadAWSimg(data[i])
            }
        }
        return data || []
    }

    async uploadAWSimg({ fileBytes, presignedUrl }) {
        let fileBytesBuffer = Buffer.from(fileBytes, 'base64')
        let fetchParams = {
            method: 'PUT',
            headers: {
                'Content-Length': fileBytesBuffer.length,
                'Content-Type': 'image/png',
            },
            body: fileBytesBuffer
        }

        try {
            let res = await fetch(presignedUrl, fetchParams)
            if (res.status == 200) {
                this.setState({
                    uploadImageData: [],
                    questionTypesIndex: -999,
                    questionInputText: '',
                })
            } else {

            }
        } catch (err) {

        }

    }


    render() {
        const { Content, Captcha } = this.props
        let accept = UploadImgType.map(v => '.' + v.toLocaleLowerCase()).join(',')

        let { questionTypes, questionTypesIndex, questionInputText, uploadImageData,
            isUploadModalVisible, isQuestionModalVisible, isShowCaptcha } = this.state

        return <>
            <Captcha
                userName={Config()?.userName}
                isShowCaptcha={isShowCaptcha}
                onSubmit={this.onSubmit.bind(this)}
            />

            <Content
                isUploadModalVisible={isUploadModalVisible}
                accept={accept}
                isQuestionModalVisible={isQuestionModalVisible}
                questionTypes={questionTypes}

                questionTypesIndex={questionTypesIndex}
                onSelect={this.selectQuestionTypes.bind(this)}

                questionInputText={questionInputText}
                changeQuestionInputText={this.changeQuestionInputText.bind(this)}

                maxLength={MaxLength}
                isAllowUploadImg={UploadImgMaxLength > uploadImageData.length}
                onSubmit={this.onSubmit.bind(this, 'open')}
                submitBtnStatus={Array.isArray(questionTypes) && !!questionTypes.length && questionTypesIndex >= 0 && !!questionInputText.length}

                uploadImageData={uploadImageData}
                selectUplodType={this.selectUplodType.bind(this)}
            />
        </>
    }
}